<app-shared-issuance 
  [isIssuance]="isIssuance"
  [isEndorsement]="isEndorsement"
  [isEnquiry]="isEnquiry"
  [isRTP]="isRTP">
</app-shared-issuance>